export const PLASTICS_MANUFACTURING_RATES_PARENT_ID = 'plastics-manufacturing-rates';

export interface PlasticsManufacturingRatesParent {
    id: string;
    createdById: string;
    createdOn: Date;
    updatedById: string;
    updatedOn: Date;
}

export const DEFAULT_PLASTICS_MANUFACTURING_RATES_PARENT: PlasticsManufacturingRatesParent = {
    id: PLASTICS_MANUFACTURING_RATES_PARENT_ID,
    createdById: '',
    createdOn: null as unknown as Date,
    updatedById: '',
    updatedOn: null as unknown as Date,
};
